import { Injectable, Injector, Optional } from '@angular/core';
import { BindingList, ViewModel, BindingObject, Repository, Entity, FrameContext, BindingData, AppContext, BindingProperty, DataTypeInfo, createEntities, EntityList } from '@farris/devkit';
import { from, EMPTY, concat, of, Subject, Observable, throwError } from 'rxjs';
import { concatMap, catchError, tap, switchMap, last, map, delay, takeLast } from 'rxjs/operators';
import { BefRepository, ResponseInfo } from '@farris/bef';
import { BatchEditDialogService } from '@farris/ui-batch-edit-dialog';
import { DateTimeHelperService } from '@farris/ui-common/date';
import { ComponentManagerService } from './component-manager.service';
import { FormLoadingService } from './form-loading/form-loading.service';
import { LanguageService } from './languag.service';
import { FormNotifyService } from './form-notify.service';
import { UploadService } from '@gsp-svc/formdoc-upload';
import { FormErrorService } from './error';

// tslint:disable: max-line-length
/**
 * æ¹éç¼è¾æå¡
 */
@Injectable()
export class BatchEditService {
  private formLoadingService: FormLoadingService;
  private onHelpClose: Subject<any>;
  constructor(
    private injector: Injector,
    private componentManagerService: ComponentManagerService,
    private viewModel: ViewModel,
    private repository: Repository<any>,
    private batchEditDialogService: BatchEditDialogService,
    private dateService: DateTimeHelperService,
    private languageService: LanguageService,
    private formNotifyService: FormNotifyService,
    private fileUploadService: UploadService
  ) {
    this.formLoadingService = this.injector.get<FormLoadingService>(FormLoadingService, null);
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
    if (!this.formNotifyService) {
      this.formNotifyService = this.injector.get<FormNotifyService>(FormNotifyService, null);
    }
    this.onHelpClose = new Subject<any>();
    this.onHelpClose.subscribe(result => {
      const { frameId = '', mapFields = '', data = [] } = result || {};
      this.onHelpCloseHandler(frameId, mapFields, data);
    });
  }
  private get formErrorService() {
    return this.injector && this.injector.get<FormErrorService>(FormErrorService, null);
  }
  /**
   * æå¼æ¹éç¼è¾å¯¹è¯æ¡
   * @param frameId frameId
   */
  public openBatchEditDialog(frameId: string, enableDictPicking: boolean | string = false) {
    if (!frameId) {
      throw new Error('frameId is required.');
    }
    if (typeof enableDictPicking === 'string') {
      enableDictPicking = (enableDictPicking === 'true' ? true : false);
    }
    if (this.batchEditDialogService) {
      let columns = [];
      if (this.viewModel) {
        const gridFrameContext: FrameContext = this.viewModel.frameContext.root.appContext.frameContextManager.getFrameContextById(frameId);
        const gridViewModel = gridFrameContext.viewModel;
        if (gridViewModel && gridViewModel.hasOwnProperty('dataGridColumnsName')) {
          // tslint:disable-next-line: no-string-literal
          const gridColumnsAttrName = gridViewModel['dataGridColumnsName'];
          columns = gridViewModel[gridColumnsAttrName];
        } else if (gridViewModel && gridViewModel.hasOwnProperty('dataGridColumns')) {
          columns = gridViewModel['dataGridColumns'];
        }
        const ids: string[] = gridViewModel.uiState['ids'] || [];
        if (!ids || ids.length < 1) {
          this.formNotifyService.warning(this.languageService.plsCheckBatchEditRows, { hideTitle: true });
          return EMPTY;
        }
        const dialogRef: any = this.batchEditDialogService.batchEdit(columns, {
          rows: ids.length,
          enableDictPicking,
          onConfirm: (inputs: Array<any>) => {
            if (Array.isArray(ids) && ids.length > 0) {
              // console.log('openBatchEditDialog', inputs);
              const appContext = this.viewModel.frameContext.appContext;
              appContext.changeDetectionController.detach();
              inputs.forEach(input => {
                this.updateBindingData(input, ids);
              });
              appContext.changeDetectionController.reattach();
            }
            dialogRef.close();
          }
        });
      }
    }
  }
  /**
   * æå¼éèå¸®å©
   * @param helpId å¸®å©id
   */
  public openHiddenHelp(helpId: string) {
    if (!helpId) {
      throw new Error('Argument error,helpId can`t be empty');
    }
    const componentManagerService = this.componentManagerService.getControl(helpId);
    if (componentManagerService) {
      componentManagerService.showDialog();
    } else {
      throw new Error(`the component which id is ${helpId} can't be found!`);
    }
  }
  /**
   * æ¸ç©ºå¸®å©å¾éï¼åªè½æè½½å°å¸®å©åäºä»¶ï¼
   */
  public clearHelpSelections() {
    const self: any = this;
    const helpElement = self.context && self.context.eventParam && self.context.eventParam.instance || null;
    if (helpElement) {
      helpElement.displayValue = '';
    }
  }
  /**
   * å¾éå½åè¡
   * @param frameId frameId
   * @param mapFields å­æ®µæ å°
   * @param primaryKeyValue å¸®å©ä¸»é®å­æ®µ
   */
  public checkCurrentRow(frameId: string, mapFields: string, primaryKeyValue: string) {
    const self: any = this;
    const helpElement = self.context && self.context.eventParam && self.context.eventParam.instance || null;
    if (!primaryKeyValue) {
      primaryKeyValue = 'id';
    }
    const mappings = JSON.parse(mapFields);
    if (helpElement) {
      frameId = frameId || this.viewModel.frameContext.frameId;
      if (frameId) {
        const frameContext = this.getFrameContextById(frameId);
        if (frameContext) {
          const bindingPath = frameContext.viewModel.bindingPath;
          if (bindingPath) {
            const bindingPaths = bindingPath.split('/').filter(p => p);
            const bindingList = frameContext.bindingData.getValue(bindingPaths) as BindingList;
            const currentRow = bindingList.currentItem;
            const path = mappings[primaryKeyValue];
            if (path) {
              const value = this.getValueByPath(currentRow, path);
              helpElement.displayValue = value;
            }
          }
        }
      }
    }
  }
  /**
   * ä»¥å¸®å©å¾éæ°æ®ä½ä¸ºä¾æ®ï¼æ¹éæ°å¢ä¸»è¡¨æ°æ®
   * @param frameId ä¸»è¡¨æå¨frameçid
   * @param mapFields å¸®å©å­æ®µä¸ä¸»è¡¨å­æ®µæ å°
   * @description ä»¥å¸®å©å¾éæ°æ®ä½ä¸ºä¾æ®ï¼æ¹éæ°å¢ä¸»è¡¨æ°æ®
   */
  public batchAppend(frameId: string, mapFields: string) {
    const self: any = this;
    const result = self.context && self.context.eventParam || [];
    if (!mapFields) {
      throw new Error('mapFields can`t be empty.');
    }
    if (result && Array.isArray(result) && result.length > 0) {
      const mappings = JSON.parse(mapFields);
      // ä¸æ¯bindingPathåæframeIdå¤ç
      let bindingPath = '/';
      const appContext = this.injector.get<AppContext>(AppContext, null);
      if (appContext) {
        const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
        if (frameContext) {
          bindingPath = frameContext.viewModel.bindingPath || '/';
        } else {
          throw new Error('frameId is invalid!');
        }
      }
      const defaultValues = [];
      result.forEach((item) => {
        const defaultValue = {};
        Object.keys(mappings).forEach((prop: string) => {
          const value = this.getValueByPath(item, prop);
          const fields = mappings[prop];
          const groups: any[] = fields.split(',').filter(p => p);
          groups.forEach((group) => {
            const paths = group.split('.').filter(p => p);
            this.setValueByPath(defaultValue, paths.join('.'), value);
          });
        });
        defaultValues.push(defaultValue);
      });
      this.formLoadingService.show();
      return this.repository.batchAppend(defaultValues).pipe(
        tap(() => this.formLoadingService.hide()),
        map(() => true)
      );
    }
    return of(true);
  }
  /**
   * ä»¥å¸®å©å¾éæ°æ®ä½ä¸ºä¾æ®ï¼æ¹éæ°å¢ä»è¡¨/ä»ä»è¡¨
   * @param frameId ä»è¡¨/ä»ä»è¡¨æå¨frameçid
   * @param mapFields å¸®å©å­æ®µä¸ä»è¡¨/ä»ä»è¡¨å­æ®µæ å°
   * @description ä»¥å¸®å©å¾éæ°æ®ä½ä¸ºä¾æ®ï¼æ¹éæ°å¢ä»è¡¨/ä»ä»è¡¨
   */
  public batchAppendByPathBasedOnHelpSelections(frameId: string, mapFields: string) {
    const self: any = this;
    const result = self.context && self.context.eventParam || [];
    if (!mapFields) {
      throw new Error('mapFields can`t be empty.');
    }
    if (result && Array.isArray(result) && result.length > 0) {
      const mappings = JSON.parse(mapFields);
      // ä¸æ¯bindingPathåæframeIdå¤ç
      let bindingPath = '/';
      const appContext = this.injector.get<AppContext>(AppContext, null);
      if (appContext) {
        const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
        if (frameContext) {
          bindingPath = frameContext.viewModel.bindingPath || '/';
        } else {
          throw new Error('frameId is invalid!');
        }
      }
      const defaultValues = [];
      result.forEach((item) => {
        const defaultValue = {};
        Object.keys(mappings).forEach((prop: string) => {
          const value = this.getValueByPath(item, prop);
          const fields = mappings[prop];
          const groups: any[] = fields.split(',').filter(p => p);
          groups.forEach(group => {
            const paths = group.split('.').filter(p => p);
            this.setValueByPath(defaultValue, paths.join('.'), value);
          });
        });
        defaultValues.push(defaultValue);
      });
      this.formLoadingService.show();
      const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
      return this.repository.batchAppendByPath(path, defaultValues).pipe(
        tap(() => this.formLoadingService.hide()),
        map(() => true)
      );
    }
    return of(true);
  }
  /**
   * æ¹éæ°å¢å¸¦éä»¶çä»è¡¨æä»ä»è¡¨æ°æ®
   * @param frameId
   * @param mapFields
   * @param attachmentInfoFieldPath éä»¶udtå­æ®µè·¯å¾ï¼å¯æ¯æå¤ä¸ªï¼ä»¥éå·åé
   * @param rootId éä»¶å­å¨æ ¹ç®å½
   * @param path éä»¶å­å¨ç®å½
   * @description æ¹éæ°å¢å¸¦éä»¶çä»è¡¨æä»ä»è¡¨æ°æ®ä¸æ¹éæ°å¢ä»è¡¨ä»ä»è¡¨æ°æ®ä¸è´ï¼å¨æ¹éæ°å¢æ°æ®çåºç¡ä¸å¢å äºéä»¶å¤å¶
   * @todo ç®åéä»¶å¤å¶å¨åç«¯è°ç¨ï¼ä¼åèµ·å¤ä¸ªè¯·æ±ï¼ä¸å­å¨å®å¨é®é¢ï¼åç»­åºå¨voéæ
   */
  public batchAppendByPathWithAttachment(frameId: string, mapFields: string, attachmentInfoFieldPath: string, rootId: string, path: string) {
    const self: any = this;
    const result = self.context && self.context.eventParam || [];
    if (!mapFields) {
      throw new Error('mapFields can`t be empty.');
    }
    if (!attachmentInfoFieldPath) {
      throw new Error('éä»¶udtå­æ®µè·¯å¾ä¸è½ä¸ºç©º');
    }
    if (result && Array.isArray(result) && result.length > 0) {
      const mappings = JSON.parse(mapFields);
      let bindingPath = '/';
      const appContext = this.injector.get<AppContext>(AppContext, null);
      // ä¿®æ­£bindingPath
      if (appContext) {
        const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
        if (frameContext) {
          bindingPath = frameContext.viewModel.bindingPath || '/';
        } else {
          throw new Error('frameId is invalid!');
        }
      }
      // å¤çéä»¶udtå­æ®µ
      const attachmentFields = attachmentInfoFieldPath.split(',').filter(p => p).map(path => path.split('/').pop());
      this.formLoadingService.show();
      // åå¤å¶éä»¶
      const copyFiles$ = from(result).pipe(concatMap((item => {
        return this.copyRowFiles(item, attachmentFields, rootId, path).pipe(
          catchError((error) => {
            this.formLoadingService.hide();
            let cafError = error.error;
            if (typeof cafError === 'string') {
              cafError = JSON.parse(cafError);
            }
            if (this.formErrorService) {
              this.formErrorService.exception(cafError.message || this.languageService.copyFailed, error);
            }
            return throwError(error);
          })
        );
      })));
      return copyFiles$.pipe(takeLast(1)).pipe(switchMap(() => {
        // æ¼è£é»è®¤å¼
        const defaultValues = this.buildDefaultValues(result, mappings);
        const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
        return this.repository.batchAppendByPath(path, defaultValues).pipe(
          tap(() => this.formLoadingService.hide()),
          map(() => true)
        );
      }));
    }
    return of(true);
  }
  /**
   * æé é»è®¤å¼æ°ç»
   * @param selectedValues
   * @param mapFields
   * @returns
   */
  private buildDefaultValues(selectedValues: any[], mapFields: { [prop: string]: any; }): any[] {
    const defaultValues = [];
    selectedValues.forEach((item) => {
      const defaultValue = {};
      Object.keys(mapFields).forEach((prop: string) => {
        // å¸®å©æ°æ®
        const value = this.getValueByPath(item, prop);
        // ç®æ å­æ®µ
        const fields = mapFields[prop];
        const groups: any[] = fields.split(',').filter(p => p);
        groups.forEach(group => {
          const paths = group.split('.').filter(p => p);
          this.setValueByPath(defaultValue, paths.join('.'), value);
        });
      });
      defaultValues.push(defaultValue);
    });
    return defaultValues;
  }
  /**
   * å¤å¶è¡ä¸­ææéä»¶
   * @param row
   * @param attachmentFields
   * @param rootId
   * @param path
   * @returns
   */
  private copyRowFiles(row: any, attachmentFields: string[], rootId: string, path: string) {
    return from(attachmentFields).pipe(
      concatMap((field: string) => {
        const attachmentId = this.getValueByPath(row, `${field}.attachmentId`);
        if (attachmentId) {
          // åéå¤å¶éä»¶çè¯·æ±ï¼è·åéä»¶id
          return this.fileUploadService.copyFile(attachmentId, rootId, path).pipe(
            tap((attachmentId: string) => {
              // å¤å¶æå
              this.setValueByPath(row, [field, 'attachmentId'].join('.'), attachmentId);
            }
            ));
        } else {
          return of(null);
        }
      })
    );
  }
  /**
   * è¡åå¸®å©å¤éæ¹éæ°å¢ææ¿æ¢å­è¡¨æ°æ®
   * @param frameId frameId, optional,ä¸ºç©ºæ¶ä½¿ç¨å½ä»¤æ§è¡æ¶æå¨çä¸ä¸æ
   * @param mapFields å­æ®µæ å°
   * @param primaryKey å¸®å©ä¸»é®å­æ®µï¼é»è®¤ä¸ºid
   * @returns
   */
  public batchAppendBasedOnRowHelpSelections(frameId: string, mapFields: string) {
    const self: any = this;
    let result: any[] = self.context && self.context.eventParam || [];
    if (!mapFields) {
      return of(true);
    }
    const mappings = JSON.parse(mapFields);
    if (!mappings || !mappings.hasOwnProperty('id')) {
      return of(true);
    }
    frameId = frameId || this.viewModel.frameContext.frameId;
    if (!frameId) {
      return of(true);
    }
    const frameContext = this.getFrameContextById(frameId);
    if (!frameContext) {
      return of(true);
    }
    setTimeout(() => {
      this.viewModel.frameContext.appContext.params.set('FORCE_END_EDIT', true);
      this.endEdit(frameContext).subscribe(() => {
        setTimeout(() => {
          this.viewModel.frameContext.appContext.params.set('FORCE_END_EDIT', false);
          if (result && Array.isArray(result) && result.length > 0) {
            const bindingPath = frameContext.viewModel.bindingPath || '/';
            const bindingPaths = bindingPath.split('/').filter(p => p);
            const defaultValues = [];
            // è·åå½åè¡
            const bindingList: BindingList = frameContext.bindingData.getValue(bindingPaths) as BindingList;
            const currentRow = bindingList.currentItem;
            const currentRowId = bindingList.currentId;
            const currentEntity = this.getEntityByPath(frameContext, bindingPaths, currentRowId);
            const headItem = result[0];
            // å¦æä»å¾éä¸æ¡ï¼ååºæ¿æ¢å½åè¡çæ å°
            if (result.length === 1) {
              // this.mappingRow(headItem, mappings, currentEntity, bindingPath);
              const data = headItem;
              Object.keys(mappings).forEach((prop: string) => {
                const value = this.getValueByPath(data, prop);
                const fields = mappings[prop];
                const groups: any[] = fields.split(',').filter(p => p);
                groups.forEach(group => {
                  const paths = group.split('.').filter(p => p);
                  frameContext.bindingData.setValue(bindingPaths.concat(paths), value, true, true);
                });
              });
              return of(true);
            } else {
              const idMapField = mappings['id'];
              const sourceItemId = this.getValueByPath(currentEntity, idMapField);
              // å¦æå½åè¡æ²¡ææ å°æå¾éç»æä¸­æ¾ä¸å°å½åè¡çæ å°
              if (!sourceItemId || result.findIndex(item => item[bindingList.primaryKey] === sourceItemId) === -1) {
                // éæ°æ å°å½åè¡
                this.mappingRow(headItem, mappings, currentEntity, bindingPath);
                result = result.slice(1);
              } else if (sourceItemId) {
                const index = result.findIndex(item => item[bindingList.primaryKey] === sourceItemId);
                // éæ°æ å°å½åè¡
                this.mappingRow(result[index], mappings, currentEntity, bindingPath);
                result.splice(index, 1);
              }
              // å½åè¡å¤çå®æ
              // å¤çæªæ å°çè¡
              const emptyRows = bindingList.toArray().filter(bindingObject => {
                const id = this.getValueByPath(bindingObject, mappings[bindingList.primaryKey]);
                return !id;
              });
              if (emptyRows && emptyRows.length > 0) {
                let rows = result;
                if (result.length > emptyRows.length) {
                  rows = result.slice(0, emptyRows.length);
                  result = result.slice(emptyRows.length);
                } else {
                  result = [];
                }
                rows.forEach((item, index) => {
                  const targetItem = emptyRows[index];
                  const entity = this.getEntityByPath(frameContext, bindingPaths, targetItem.primaryKeyValue);
                  this.mappingRow(item, mappings, entity, bindingPath);
                });
              }
              // å¤çå©ä½å¾é
              result.forEach((item) => {
                const defaultValue = {};
                Object.keys(mappings).forEach((prop: string) => {
                  const value = this.getValueByPath(item, prop);
                  const fields = mappings[prop];
                  const groups: any[] = fields.split(',').filter(p => p);
                  groups.forEach(group => {
                    const paths = group.split('.').filter(p => p);
                    this.setValueByPath(defaultValue, paths.join('.'), value);
                  });
                });
                defaultValues.push(defaultValue);
              });
              if (defaultValues.length > 0) {
                this.formLoadingService.show();
                const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
                this.repository.batchAppendByPath(path, defaultValues).pipe(
                  tap(() => this.formLoadingService.hide())
                ).subscribe();
              }
            }
          }
        }, 350);
      });
    }, 50);
    return of(true);
  }
  /**
   * å¤å¶ä¸»è¡¨æ°æ®
   * @param id è¦å¤å¶çæ°æ®id
   * @param fields è¦å¤å¶çå­æ®µ
   * @description ä»æ¯æå¤å¶ä¸»è¡¨æ°æ®
   * @deprecated è¯¥æ¹æ³å·²è¢«åºå¼ï¼è¯·ä½¿ç¨cloneæ¹æ³æ¿ä»£ã
   */
  public copy(id: string): Observable<any> {
    if (!id) {
      this.formNotifyService.warning(this.languageService.plsSelectCopyData, { hideTitle: true });
      return EMPTY;
    }

    const befRepository = this.repository as BefRepository<any>;
    const baseUri = befRepository.restService.baseUri;
    const url = `${baseUri}/service/copymainobjvoaction`;
    const requestInfo = befRepository.restService.buildRequestInfo();
    const body = {
      requestInfo,
      dataID: id
    };
    const options = {
      body
    };
    this.formLoadingService.show();
    return befRepository.proxy.request(url, 'PUT', null, options).pipe(
      tap(() => {
        this.formLoadingService.hide();
      }),
      map((responseInfo: ResponseInfo) => {
        const returnValue = responseInfo.returnValue;
        const entity = this.repository.buildEntity(returnValue);
        this.repository.entityCollection.addEntity(entity);
        return entity;
      }),
    );
  }
  /**
   * å¤å¶æ°æ®ï¼æ¯æä¸»è¡¨ãä»è¡¨ãä»ä»è¡¨ï¼
   * @param id è¦å¤å¶çè¡
   * @param path è¯·æ±è·¯å¾
   * @returns
   */
  public clone(id: string, path: string) {
    if (!id) {
      this.formNotifyService.warning(this.languageService.plsSelectCopyData, { hideTitle: true });
      return EMPTY;
    }
    if (!path) {
      this.formNotifyService.warning(this.languageService.pathIsRequired, { hideTitle: true });
      return EMPTY;
    }
    if (!path.startsWith('/')) {
      path = '/' + path;
    }
    path = path.toLowerCase();
    const bindingPath = this.viewModel.bindingPath;
    const befRepository = this.repository as BefRepository<any>;
    const baseUri = befRepository.restService.baseUri;
    const url = `${baseUri}${path}`;
    const requestInfo = befRepository.restService.buildRequestInfo();
    const ids = this.buildIds(bindingPath);
    ids.push(id);
    const body = {
      requestInfo,
      dataID: ids.join(',')
    };
    const options = {
      body
    };
    this.formLoadingService.show();
    return befRepository.proxy.request(url, 'PUT', null, options).pipe(
      tap(() => {
        this.formLoadingService.hide();
      }),
      map((responseInfo: ResponseInfo) => {
        const returnValue = responseInfo.returnValue;
        let entity = null;
        if (bindingPath.split('/').filter(p => p).length === 0) {
          entity = this.repository.buildEntity(returnValue);
          this.repository.entityCollection.addEntity(entity, true);
        } else {
          const fpath = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
          entity = befRepository.entityManager.appendEntityByPath(fpath, returnValue, returnValue, true);
        }
        return entity;
      }),
    );
  }
  /**
   * å¸¦éä»¶çå¤å¶
   * @param id
   * @param url
   * @param attachmentInfoFieldPath
   * @param rootId
   * @param path
   * @returns
   */
  public cloneWithAttachment(id: string, url: string, attachmentInfoFieldPath: string, rootId: string, path: string) {
    if (!id) {
      this.formNotifyService.warning(this.languageService.plsSelectCopyData, { hideTitle: true });
      return EMPTY;
    }
    if (!url) {
      this.formNotifyService.warning(this.languageService.pathIsRequired, { hideTitle: true });
      return EMPTY;
    }
    if (!attachmentInfoFieldPath) {
      throw new Error('éä»¶udtå­æ®µè·¯å¾ä¸è½ä¸ºç©º');
    }
    if (!url.startsWith('/')) {
      url = '/' + url;
    }
    url = url.toLowerCase();
    const bindingPath = this.viewModel.bindingPath;
    const befRepository = this.repository as BefRepository<any>;
    const baseUri = befRepository.restService.baseUri;
    const uri = `${baseUri}${url}`;
    const requestInfo = befRepository.restService.buildRequestInfo();
    const ids = this.buildIds(bindingPath);
    ids.push(id);
    const body = {
      requestInfo,
      dataID: ids.join(',')
    };
    const options = {
      body
    };
    this.formLoadingService.show();
    const attachmentFields = attachmentInfoFieldPath.split(',').filter((p) => p).map((path) => path.split('/').pop());
    return befRepository.proxy.request(uri, 'PUT', null, options).pipe(
      switchMap((responseInfo: ResponseInfo) => {
        const entityData = responseInfo.returnValue;
        let entity = null;
        if (bindingPath.split('/').filter((p) => p).length === 0) {
          entity = this.repository.buildEntity(entityData);
          this.repository.entityCollection.addEntity(entity, true);
        } else {
          const fpath = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
          entity = befRepository.entityManager.appendEntityByPath(fpath, entityData, entityData, true);
        }
        // å¤å¶éä»¶
        return this.copyRowFiles(entity, attachmentFields, rootId, path).pipe(
          switchMap(() => {
            this.formLoadingService.hide();
            return this.repository.updateAllChanges().pipe(map(() => {
              return entity;
            }));
          }),
          catchError((error) => {
            this.formLoadingService.hide();
            // æ¸ç©ºå®ä½éä»¶å±æ§
            this.clearAttachmentInfo(entity, attachmentFields);
            let cafError = error.error;
            if (typeof cafError === 'string') {
              cafError = JSON.parse(cafError);
            }
            if (this.formErrorService) {
              this.formErrorService.exception(cafError.message || this.languageService.copyFailed, error);
            }
            return EMPTY;
          })
        );
      }),
    );
  }
  private clearAttachmentInfo(entity: Entity, attachmentFields: string[]) {
    try {
      attachmentFields.forEach((attachmentField: string) => {
        this.setValueByPath(entity, [attachmentField, 'attachmentId'].join('.'), null);
        this.setValueByPath(entity, [attachmentField, 'fileName'].join('.'), null);
        this.setValueByPath(entity, [attachmentField, 'fileCreateTime'].join('.'), null);
        this.setValueByPath(entity, [attachmentField, 'fileSize'].join('.'), null);
      });
    } catch (e) {
      console.log(e);
    }
  }
  //#region æ§çå®ç°

  /**
   * å¤å¶è¡
   * @param frameId frameId
   * @param ignoreFields å¤å¶æ¶å¿½ç¥å­æ®µ
   * @param repeat éå¤å¤å¶æ¬¡æ°ï¼é»è®¤ä¸º1
   */
  public copyRow(frameId: string, ignoreFields: string, repeat: number = 1) {
    if (typeof repeat !== 'number') {
      repeat = parseInt(repeat, 10);
    }
    if (repeat < 1) {
      throw new Error('ArgumentError: repeat must >= 1');
    }
    // è·åå½åè¡
    const frameContext = this.viewModel.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
    const primaryValue = frameContext.bindingData.list.currentId;
    const bindingPath = frameContext.viewModel.bindingPath || '/';
    let bindingData = null;
    let currentItem: BindingObject = null;
    if (bindingPath === '/') {
      // ä¸»è¡¨ç´æ¥åå½åè¡
      currentItem = frameContext.bindingData.list.currentItem;
    } else {
      // åä»è¡¨/ä»ä»è¡¨å½åè¡
      const paths = bindingPath.split('/').filter(p => p);
      currentItem = (frameContext.bindingData.getValue(paths) as BindingList).currentItem;
    }
    bindingData = currentItem.toJSON();
    if (!currentItem.primaryKeyValue) {
      if (this.formNotifyService) {
        this.formNotifyService.warning(this.languageService.plsSelectCopyData, { hideTitle: true });
      }
      return EMPTY;
    }
    const ignoreFieldsArray = ignoreFields.split(',').filter(item => item);

    const sources = new Array(repeat);
    return from(sources).pipe(
      concatMap(() => {
        let action$ = null;
        if (bindingPath !== '/') {
          const fullPath = this.buildPath(bindingPath, primaryValue);
          action$ = this.repository.appendByPath(fullPath);
        } else {
          action$ = this.repository.append();
        }
        return action$.pipe(
          tap((entity: Entity) => {
            // ä¿®æ­£å®ä½ä¸»é®
            bindingData[entity.primaryKey] = entity.primaryValue;
            // å¿½ç¥æå®å­æ®µ
            ignoreFieldsArray.forEach((field: string) => {
              const extractedFields = field.split('.').filter(item => item);
              if (extractedFields.length === 1) {
                delete bindingData[field];
              }
              const parent = extractedFields.slice(0, -1).reduce((prev, current, index) => {
                return prev[current];
              }, bindingData);
              delete parent[extractedFields[extractedFields.length - 1]];
            });
            bindingData = Object.assign({}, entity.toJSON(), bindingData);
            entity.load(bindingData, { loadChild: false });
          }),
          catchError(() => {
            return EMPTY;
          })
        );
      })
    );
  }
  /**
   * å¢éå¤éå¸®å©æ¹éèµå¼å¸®å©åäºä»¶
   * @param frameId frameId
   * @param mapFields å­æ®µæ å°
   * @param associatedField å³èå­æ®µ
   */
  public afterIncrementalSelectHelpClose(frameId: string, mapFields: string, associatedField: string) {
    const self: any = this;
    const result = self.context && self.context.eventParam || [];
    // tslint:disable-next-line: max-line-length
    // const mapping = '{"id":"userRef.userRef", "name":"name", "sex":"sex","age":"userRef.userRef_Age","address":"userRef.userRef_Address","birthday":"userRef.userRef_Birthday","height":"userRef.userRef_Height","isMarried":"userRef.userRef_IsMarried"}';
    if (!associatedField) {
      throw new Error('associated field can`t be empty.');
    }
    if (!mapFields) {
      throw new Error('mapFields can`t be empty.');
    }
    const mappings = JSON.parse(mapFields);
    const foreignKey = associatedField;
    // å°éæ©äººåä¿å­å°uistateä¸­
    const rootFrameContext = this.viewModel.frameContext.root;
    // ä¸æ¯bindingPathåæframeIdå¤ç
    let bindingPath = '/';
    const appContext = this.injector.get<AppContext>(AppContext, null);
    if (appContext) {
      const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
      if (frameContext) {
        bindingPath = frameContext.viewModel.bindingPath || '/';
      } else {
        throw new Error('frameId is invalid!');
      }
    }
    // tslint:disable-next-line: no-string-literal
    rootFrameContext.uiState['selections'] = result;
    if (result && Array.isArray(result)) {
      // æ ¹æ®bindingPathè·åbindingdataä¸­ç°ææ°æ®
      const bindingPaths = bindingPath.split('/').filter(item => item);
      const currentData: BindingList = this.viewModel.bindingData.getValue(bindingPaths);
      const currentDataArray = currentData.toArray();
      // æ¾å°resultä¸­æï¼ä½bindingDataä¸­æ²¡æçï¼ä¸ºå¾æ°å¢é¡¹
      const appends = [];
      result.reduce((prev: Array<any>, item) => {
        const itemId = item && item[currentData.primaryKey] || null;
        const isExist = currentDataArray.find((bindingObject: BindingObject) => bindingObject[foreignKey][foreignKey] === itemId);
        if (!isExist) {
          prev.push(item);
        }
        return prev;
      }, appends);

      // æ¾å°bindingDataä¸­æï¼resultä¸­æ²¡æçï¼ä¸ºå¾å é¤é¡¹
      const removes = [];
      currentDataArray.reduce((results: any, item: BindingObject) => {
        const index = result.findIndex(selectItem => selectItem[currentData.primaryKey] === item[foreignKey][foreignKey]);
        if (index === -1) {
          results.push(item.primaryKeyValue);
        }
        return results;
      }, removes);

      // console.log('addItems', appends, 'removeItems', removes);
      // è°ç¨åç«¯æ¥å£æ°å¢æ°æ®
      const addAction$ = from(appends).pipe(
        concatMap(item => {
          const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
          return this.repository.appendByPath(path).pipe(
            tap((entity: Entity) => {
              Object.keys(mappings).forEach(prop => {
                const value = this.getValueByPath(item, prop);
                const fields = mappings[prop];
                const groups: any[] = fields.split(',').filter(p => p);
                groups.forEach(group => {
                  const paths = group.split('.').filter(p => p);
                  this.setValueByPath(entity, paths.join('.'), value);
                });
              });
            }),
            catchError(() => {
              return EMPTY;
            })
          );
        })
      );

      const removeAction$ = from(removes).pipe(
        concatMap(item => {
          const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
          return this.repository.removeByPath(path, item).pipe(
            tap(() => {
              const befRepository: BefRepository<any> = this.repository as BefRepository<any>;
              befRepository.entityManager.removeEntityByPath(path, item);
            }),
            catchError(() => {
              return EMPTY;
            })
          );
        })
      );
      if (!appends && !removes || appends && appends.length < 1 && removes && removes.length < 1) {
        return of(true);
      }
      return concat(addAction$, removeAction$).pipe(
        catchError(() => EMPTY)
      );
    }
    return of(true);
  }
  // todo:æ¨¡æç¨æ·æä½ï¼å¾åç«¯æ¥å£æ¯æä¸»è¡¨æ¹éæ°å¢åéå
  /**
   * å¤éå¸®å©æ¹éèµå¼å¸®å©åäºä»¶
   */
  public beforeMultiSelectHelpOpen() {
    return this.clearHelpSelections();
  }
  /**
   * å¤éå¸®å©æ¹éèµå¼å¸®å©åäºä»¶
   * @param frameId ç»å®è·¯å¾
   * @param mapFields å­æ®µæ å°
   * @param commandFrameId åè°å½ä»¤æå¨frameId
   * @param commandName åè°å½ä»¤
   * @deprecated æ¨¡æç¨æ·æä½ï¼å¾æ¹éèµå¼æ¯æä¸»è¡¨ååºå¼
   */
  public afterMultiSelectHelpClose(frameId: string, mapFields: string, commandFrameId?: string, commandName?: string) {
    const self: any = this;
    const result = self.context && self.context.eventParam || [];
    if (result && Array.isArray(result)) {
      // è°ç¨åç«¯æ¥å£æ°å¢æ°æ®
      if (!result || result.length < 1) {
        return of(true);
      }
      this.onHelpClose.next({ frameId, mapFields, data: result, commandFrameId, commandName });
      return of(true);
    }
    return of(true);
  }
  /**
    * å¸®å©å³é­åå¤çå¨
    * @param frameId frameid
    * @param mapFields mapFields
    * @param result å¸®å©æ°æ®ç»æ
    */
  private onHelpCloseHandler(frameId: string, mapFields: string, result: any[]) {
    if (!mapFields) {
      throw new Error('mapFields can`t be empty.');
    }
    const mappings = JSON.parse(mapFields);
    // ä¸æ¯bindingPathåæframeIdå¤ç
    let bindingPath = '/';
    const appContext = this.injector.get<AppContext>(AppContext, null);
    if (appContext) {
      const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
      if (frameContext) {
        bindingPath = frameContext.viewModel.bindingPath || '/';
      } else {
        throw new Error('frameId is invalid!');
      }
    }
    // å°éæ©äººåä¿å­å°uistateä¸­
    const rootFrameContext = this.viewModel.frameContext.root;
    const befRepository = this.repository as BefRepository<any>;
    const bindingPaths = bindingPath.split('/').filter(p => p);
    // tslint:disable-next-line: no-string-literal
    rootFrameContext.uiState['selections'] = result;
    if (result && Array.isArray(result)) {
      const addAction$ = from(result).pipe(
        concatMap(item => {
          const requestInfo = befRepository.restService.buildRequestInfo();
          if (bindingPaths.length > 0) {
            const path = this.buildPath(bindingPath, this.viewModel.bindingData.list.currentId);
            return befRepository.restService.createByPath(path, requestInfo).pipe(
              tap((responseInfo: ResponseInfo) => {
                const data = responseInfo.returnValue;
                const newEntity = befRepository.entityManager.appendEntityByPath(path, data, data);
                Object.keys(mappings).forEach(prop => {
                  const value = this.getValueByPath(item, prop);
                  const fields = mappings[prop];
                  const groups: any[] = fields.split(',').filter(p => p);
                  groups.forEach(group => {
                    const paths = group.split('.').filter(p => p);
                    this.setValueByPath(newEntity, paths.join('.'), value);
                  });
                });
                return newEntity;
              })
            );
          } else {
            return befRepository.restService.create(null, requestInfo).pipe(
              tap((responseInfo: ResponseInfo) => {
                const data = responseInfo.returnValue;
                const newEntity = this.repository.buildEntity(data);
                Object.keys(mappings).forEach(prop => {
                  const value = this.getValueByPath(item, prop);
                  const fields = mappings[prop];
                  const groups: any[] = fields.split(',').filter(p => p);
                  groups.forEach(group => {
                    const paths = group.split('.').filter(p => p);
                    this.setValueByPath(newEntity, paths.join('.'), value);
                  });
                });
                this.repository.entityCollection.addEntity(newEntity);
                return newEntity;
              })
            );
          }
        })
      );
      // const formLoadingService = this.injector.get<FormLoadingService>(FormLoadingService, null);
      if (this.formLoadingService) {
        this.suspendFrameContextEvent(frameId);
        this.formLoadingService.show();
        this.formLoadingService.setSuspend(true);
      }
      return addAction$.pipe(
        last(),
      ).pipe(
        switchMap(() => {
          const primaryValue = this.viewModel.bindingData.list.currentId;
          if (primaryValue) {
            return befRepository.updateChangesById(primaryValue);
          } else {
            return of(null);
          }
        })
      ).subscribe(() => {
        if (this.formLoadingService) {
          this.resumeFrameContextEvent(frameId);
          this.formLoadingService.setSuspend(false);
          this.formLoadingService.hide();
        }
      }, () => {
        if (this.formLoadingService) {
          this.resumeFrameContextEvent(frameId);
          this.formLoadingService.setSuspend(false);
          this.formLoadingService.hide();
        }
      });
    }
    return of(null);
  }
  private suspendFrameContextEvent(frameId: string) {
    const appContext = this.injector.get<AppContext>(AppContext, null);
    if (appContext) {
      const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
      frameContext.suspend = true;
    }
  }
  private resumeFrameContextEvent(frameId: string) {
    const appContext = this.injector.get<AppContext>(AppContext, null);
    if (appContext) {
      const frameContext = appContext.frameContextManager.getFrameContextById(frameId);
      frameContext.suspend = false;
      frameContext.appContext.messagePipe.next('bindData');
    }
  }

  //#endregion
  private setValueByPath(target: object, path: string, value: any) {
    if (target) {
      const paths = path.split('.');
      if (paths.length <= 1) {
        target[path] = value;
      } else {
        paths.slice(0, -1).reduce((prev, path) => {
          if (!(prev.hasOwnProperty(path) || prev['__proto__'].hasOwnProperty(path))) {
            prev[path] = {};
          }
          return prev[path];
        }, target)[paths[paths.length - 1]] = value;
      }
    }
  }
  private getValueByPath(target: object, path: string) {
    const paths = path.split('.');
    if (paths.length < 1) {
      return;
    }
    if (paths.length === 1) {
      return target[path];
    }
    let result = null;
    paths.forEach((prop, index) => {
      if (index === 0) {
        result = target && target[prop] || null;
      } else {
        result = result && result[prop] || null;
      }
    });
    return result;
  }
  /**
   * æé å­è¡¨è·¯å¾
   * @param bindingPath ç»å®è·¯å¾
   * @param id id
   */
  private buildPath(bindingPath: string, id: any) {
    let path = '/' + id;
    const subPaths = bindingPath.split('/');
    if (subPaths.length > 0) {
      // eg:bindingPathå½¢å¦/edus/grades,splitåæ¯['', 'edus', 'grades']
      // å æ­¤indexä»1å¼å§
      for (let index = 1; index < subPaths.length - 1; index++) {
        const subPath = subPaths[index];
        const subData = this.viewModel.bindingData[subPath];
        if (!subData || !subData.currentId) {
          throw Error(`è·åå­è¡¨å®æ´è·¯å¾åºéï¼æ¾ä¸å°${subData}å¯¹åºçå­è¡¨ï¼æå¯¹åºå­è¡¨æ²¡æå½åè¡ã`);
        }
        path += `/${subPath}/${subData.currentId}`;
      }
    }
    path += '/' + subPaths[subPaths.length - 1];

    return path;
  }
  /**
   * è·åç»å®è·¯å¾çå½åè¡æ°ç»
   * @param bindingPath bindingPath
   * @returns
   */
  private buildIds(bindingPath: string): string[] {
    const bindingPaths = bindingPath.split('/').filter(p => p);
    const primaryValue = this.viewModel.bindingData.list.currentId;
    const result = [];
    const paths = [];
    if (bindingPaths.length > 0) {
      result.push(primaryValue);
      // ä»è¡¨æä»ä»è¡¨è¦å¤å¶çè¡ä¸ä¸å®æ¯å½åè¡ï¼ç¨æ·å¯ä»¥æå®
      bindingPaths.pop();
      bindingPaths.forEach((path: string) => {
        paths.push(path);
        const bindingList = this.viewModel.bindingData.getValue(paths) as BindingList;
        if (bindingList) {
          result.push(bindingList.currentId);
        }
      });
    }
    return result;
  }
  private updateBindingData(input: any, ids: Array<any>) {
    const { controlType = null, value = null, options = {}, dataType = null } = input || {};
    if (controlType) {
      // å¯¹å¸®å©åç¹æ®å¤ç
      if (controlType === 'lookup' || controlType === 'combo-lookup') {
        const mapFields = options.mapFields;
        this.updateLookupField(ids, value, mapFields);
      } else {
        this.updateSimpleField(ids, value, input);
      }
    }
  }
  private updateSimpleField(ids: Array<any>, value: any, column: any) {
    if (!column) {
      return;
    }
    const currentColumnType = column.dataType;
    // å­å¨è¡ç¼è¾å¨
    let result = value;
    if (currentColumnType === 'date') {
      const dateStr = this.dateService.formatTo(value, 'yyyy-MM-dd');
      result = dateStr;
    } else if (currentColumnType === 'number') {
      result = Number(value) || 0;
    }
    const field = column.field;
    ids.forEach(id => {
      this.updateBindingList(id, field, result);
    });
  }
  private updateLookupField(ids: Array<any>, helpData: any, mapFields: any) {
    if (!mapFields) {
      return;
    }
    let helpFields = Object.keys(mapFields);
    const idIndex = helpFields.findIndex(item => item === 'id');
    if (helpFields.includes('id') && idIndex !== 0) {
      helpFields.splice(idIndex, 1);
      helpFields = ['id', ...helpFields];
    }
    if (!helpData) {
      helpFields.reverse();
    }
    helpFields.forEach((helpField: any) => {
      let helpValue: any = '';
      if (helpData) {
        if (helpData instanceof Array) {
          helpValue = helpData.map((item: any) => {
            return this.getValue(helpField, item);
          }).join(',');
        } else {
          helpValue = this.getValue(helpField, helpData);
        }
      }
      ids.forEach((id) => {
        const targetFields = mapFields[helpField].split(',').filter((item) => item);
        targetFields.forEach((targetField: any) => {
          this.updateBindingList(id, targetField, helpValue);
        });
      });
    });
  }
  private updateBindingList(primaryValue: any, propertyName: string, value: any) {
    const viewModel = this.viewModel || null;
    if (!viewModel || !propertyName) {
      return;
    }
    // æ´æ°ä¸»è¡¨é¨åè¡çå­æ®µ
    const propertyNames = propertyName.split('.').filter(item => item);
    const bindingObject = this.bindingList.findById(primaryValue);

    if (propertyNames.length < 2) {
      bindingObject.setValue(propertyName, value, true, true);
    } else {
      let targetBindingObject = null;
      const fpaths = propertyNames.slice(0, propertyNames.length - 1);
      const targetPropertyName = propertyNames[propertyNames.length - 1];
      fpaths.forEach(prop => {
        targetBindingObject = targetBindingObject && targetBindingObject[prop] || bindingObject[prop];
      });
      // todo:éè¦æ·»å å¼ååäºä»¶
      targetBindingObject.setValue(targetPropertyName, value, true, true);
    }
  }
  private getBindingPathArray(): any[] {
    const path = this.viewModel.bindingPath;
    if (path) {
      return path.split('/').filter(n => n !== '');
    }
    return [];
  }
  private getValue(f: string, data: any) {
    let val = '';
    if (f.indexOf('.') === -1) {
      val = data[f];
    } else {
      val = f.split('.').reduce((a, b) => {
        return a[b];
      }, data);
    }

    return val;
  }
  protected get bindingList(): BindingList {
    // æ ¹å®ä½
    if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
      return this.viewModel.bindingData.list;
    }
    // å­å®ä½
    let bindingPath = this.viewModel.bindingPath.substr(1);
    bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
    const paths = bindingPath.split('/');

    const filteredPaths = paths.filter((part: string) => {
      return part !== '';
    });
    return this.viewModel.bindingData.getValue(filteredPaths);
  }
  /**
   * æ ¹æ®æ å°å°æ°æ®èµå¼ç»bindingData
   * @param data
   * @param mapFields
   * @param bindingData
   */
  private mappingRow(data: any, mapFields: any, entity: Entity, bindingPath: string) {
    Object.keys(mapFields).forEach((prop: string) => {
      const value = this.getValueByPath(data, prop);
      const fields = mapFields[prop];
      const groups: any[] = fields.split(',').filter(p => p);
      groups.forEach(group => {
        const paths = group.split('.').filter(p => p);
        this.setValueByPath(entity, paths.join('.'), value);
      });
    });
  }
  /**
   * éè¿frameIdè·åå¯¹åºçç»ä»¶ä¸ä¸æ
   * @param frameId frameId
   * @returns
   */
  private getFrameContextById(frameId: string): FrameContext | null {
    if (!frameId) {
      return null;
    }
    const appContext = this.injector.get<AppContext>(AppContext, null);
    let frameContext: FrameContext = null;
    if (appContext) {
      frameContext = appContext.frameContextManager.getFrameContextById(frameId);
    }
    return frameContext;
  }
  private getEntityByPath(frameContext: FrameContext, bindingPaths: any[], currentId: string) {
    bindingPaths = [...bindingPaths];
    const id = frameContext.bindingData.list.currentId;
    const entity: Entity = frameContext.repository.entityCollection.getEntityById(id) as Entity;
    let item: Entity = entity;
    const paths = [];
    const tailPath = bindingPaths.pop();
    const parent = bindingPaths.reduce((object: Entity, path: string) => {
      paths.push(path);
      if (object && (object.hasOwnProperty(path) || object['__proto__'].hasOwnProperty(path))) {
        const value = object[path];
        if (value && value instanceof EntityList) {
          const bindingList = frameContext.bindingData.getValue(paths) as BindingList;
          const currentItemId = bindingList.currentId;
          return value.get(currentItemId);
        } else {
          return value;
        }
      } else {
        return null;
      }
    }, item);
    if (parent instanceof Entity) {
      const list = parent[tailPath] as EntityList<any>;
      if (list) {
        return list.get(currentId);
      } else {
        throw new Error(`æ æçbindingPath.`);
      }
    } else {
      throw new Error(`æ æçbindingPath.`);
    }
  }
  private endEdit(frameContext: FrameContext) {
    const appContext: AppContext = frameContext && frameContext.getFormAppContext();
    return of(null).pipe(
      tap(() => {
        if (appContext) {
          appContext.messagePipe.next({ type: 'endEdit' });
        }
      }),
      // todo: ä¸åºè¯¥ä½¿ç¨delayï¼åºè¯¥ä¸²æµ
      delay(5)
    );
  }
}
